<template>
  <div v-if="show" class="unsaved-changes-modal-overlay" @click.self="handleStay">
    <div class="unsaved-changes-modal">
      <div class="unsaved-changes-modal-header">
        <i class="bi bi-exclamation-triangle"></i>
        <span>Unsaved Changes</span>
      </div>
      <div class="unsaved-changes-modal-body">
        <p>You have unsaved changes. Are you sure you want to leave?</p>
        <p class="unsaved-changes-modal-warning">
          <i class="bi bi-info-circle"></i>
          Your changes will be lost if you continue.
        </p>
      </div>
      <div class="unsaved-changes-modal-actions">
        <button 
          class="unsaved-changes-modal-btn-secondary" 
          @click="handleStay"
        >
          <i class="bi bi-x"></i>
          Stay on Page
        </button>
        <button 
          class="unsaved-changes-modal-btn-primary" 
          @click="handleLeave"
        >
          <i class="bi bi-arrow-right"></i>
          Leave Page
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import './UnsavedChangesModal.css';

export default {
  name: 'UnsavedChangesModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['stay', 'leave'],
  methods: {
    handleStay() {
      this.$emit('stay');
    },
    handleLeave() {
      this.$emit('leave');
    }
  }
};
</script>

<style src="./UnsavedChangesModal.css"></style>
